export const MAX_INTERACTION_WINDOWS_STATE = 20;
export const MAX_HISTORICAL_CONVERSATIONS = 5;
export const MAX_HISTORICAL_ELEMENTS = 25;
export const MAX_HISTORICAL_EMAILS = 10;
